import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import styles from "./style.module.scss";
import { RouteComponentProps } from "react-router";
import { FormComponentProps } from "antd/es/form";
import { Form, Icon, Button, Modal, Select } from "antd";
import queryString from "query-string";
import VerifyEmailFormat from "../../utilities/verifyEmailFormat";
import InviteMemberCell from "../../components/inviteMemberCell";
import { MUTATE, QUERY } from "../../utilities/network";
import Membership from "../../store/membership";
import { GET_GROUPS, GroupType } from "../groupList";
import CONST from "../../utilities/constant";
import { Button as MuiButton } from "@material-ui/core";

const FormItemLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 20,
  },
};
const FormItemLayoutWithOutLabel = {
  wrapperCol: {
    span: 20,
    offset: 4,
  },
};

@observer
class InviteMemberPage extends Component<FormComponentProps & RouteComponentProps<{}>> {
  groupId = 0;
  groupName = "";
  @observable members: Array<number> = [+new Date()];
  @observable submitting = false;
  @observable groups: Array<GroupType> = [];

  constructor(props: any) {
    super(props);

    this._getParams().then();
  }

  async _getParams() {
    const params = queryString.parse(decodeURI(this.props.location.search), {
      parseNumbers: true,
    }) as { id?: number; name?: string };

    const { id, name } = params;
    if (id && name) {
      this.groupId = id;
      this.groupName = name;
    } else {
      await this._fetchGroups();
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <article>Invite new members</article>
        <div className={styles.content}>
          <Form className={styles.form}>
            {this._renderGroupSelect()}

            {this.members.map((key, index) => {
              const removeIconCls =
                this.members.length === 1 ? styles.email_remove_icon_disable : undefined;
              return (
                <Form.Item
                  {...(index === 0 ? FormItemLayout : FormItemLayoutWithOutLabel)}
                  label={index === 0 && "Members"}
                  required={true}
                  key={key}
                >
                  {getFieldDecorator(`members[${key}]`, {
                    validateTrigger: ["onBlur"],
                    rules: [
                      {
                        validator: this._verifyNameAndEmailInput,
                      },
                    ],
                  })(
                    <InviteMemberCell
                      className={styles.email_item}
                      memberships={Membership.invitationTypes}
                    />,
                  )}
                  <Icon
                    className={removeIconCls}
                    type="minus-circle-o"
                    onClick={() => this._removeMemberItem(key)}
                  />
                </Form.Item>
              );
            })}

            <Form.Item {...FormItemLayoutWithOutLabel}>
              <Button type="dashed" onClick={this._addMemberItem} style={{ width: "100%" }}>
                <Icon type="plus" />
                Add member
              </Button>
            </Form.Item>

            <Form.Item {...FormItemLayoutWithOutLabel}>
              <MuiButton
                color="primary"
                onClick={this._onSubmit}
                disabled={this.submitting}
                variant="contained"
              >
                Submit
              </MuiButton>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }

  _renderGroupSelect = () => {
    if (this.groupId && this.groupName) {
      return (
        <Form.Item {...FormItemLayout} label="Group">
          <span className={styles.group_title}>{this.groupName}</span>
        </Form.Item>
      );
    }

    return (
      <Form.Item {...FormItemLayout} label="Group" required={true}>
        {this.props.form.getFieldDecorator("groupId", {
          rules: [
            {
              required: true,
              message: `Please choose a group.`,
            },
          ],
        })(
          <Select
            className={styles.group_title}
            placeholder="Which group do you want the member to belong to?"
          >
            {this.groups.map((group) => (
              <Select.Option value={group.group_id} key={group.group_id}>
                {group.name}
              </Select.Option>
            ))}
          </Select>,
        )}
      </Form.Item>
    );
  };

  _verifyNameAndEmailInput = (
    rule: any,
    value:
      | { name: string; email: string; membership_id: number; start_datetime?: Date }
      | undefined,
    callback: (errorMsg?: string) => void,
  ) => {
    if (!value) {
      callback("Please input member's information");
    } else if (value.name.length === 0) {
      callback("Please input member's name");
    } else if (value.email.length === 0) {
      callback("Please input member's E-mail");
    } else if (!VerifyEmailFormat(value.email)) {
      callback("Invalid E-mail");
    } else if (!value.start_datetime) {
      callback("Please select start time for this member.");
    } else if (value.membership_id === 0) {
      callback("Please select membership type");
    }

    callback();
  };

  _addMemberItem = () => {
    this.members.push(+new Date());
  };

  _removeMemberItem = (removeKey: number) => {
    if (this.members.length > 1) {
      this.members = this.members.filter((e) => e !== removeKey);
    }
  };

  _fetchGroups = async () => {
    this.groups = (await QUERY<{ groups: Array<GroupType> }>(GET_GROUPS)).groups.filter(
      (e) => e.group_id !== CONST.B2C_GROUP_ID,
    );
  };

  _onSubmit = () => {
    this.props.form.validateFields(async (error, values) => {
      if (!error) {
        try {
          if (values.groupId) {
            this.groupId = values.groupId;
          }
          const members: Array<{
            name: string;
            email: string;
            membership_id: number;
            programme_id: number;
          }> = Object.values(values.members);

          members.forEach((e) => (e.programme_id = this.groupId));

          this.submitting = true;
          await MUTATE(INVITE_MEMBERS, { members });

          Modal.success({
            title: "Invited members successfully!",
            okText: "Great",
            onOk: this._onSubmitSuccess,
          });
        } catch (e) {
          console.log(e);
          Modal.error({
            title: "Failed to invite members!",
            content: e.message,
            okText: "Try again later",
          });
        } finally {
          this.submitting = false;
        }
      }
    });
  };

  _onSubmitSuccess = () => {
    if (this.groupName && this.groupId) {
      this.props.history.goBack();
    } else {
      this.props.history.replace("/admin/members");
    }
  };
}

export default Form.create()(InviteMemberPage);

const INVITE_MEMBERS = `
mutation($members: [NewMemberInput!]!) {
  inviteNewMembers(members: $members)
}`;
